export const DiagnosticEnum = [
  'HEALTHY',
  'SICK',
  'ABNORMAL',
  'NEGATIVE',
  'HOMOZYGOUS_WILD_TYPE',
  'HOMOZYGOUS_MUTATED',
  'HETEROZYGOUS'
];